import type { Experience } from '../types';

export const experience: Experience[] = [
  {
    id: 'sovereign-solutions',
    company: 'Sovereign Solutions India Private Limited',
    position: 'Software Engineer',
    duration: 'Dec 2021 - Nov 2025',
    location: 'Bengaluru',
    description: 'Leading frontend development for scalable web applications across diverse industries, focusing on performance optimization and user experience.',
    technologies: ['JavaScript', 'TypeScript', 'React.js', 'Next.js', 'Redux Thunk', 'Redux Toolkit', 'Context Api', 'HTML', 'CSS', 'SCSS', 'Bootstrap', 'Ant Design', 'Animations', 'Lodash'],
    achievements: [
      'Led end-to-end frontend development for Meeko World, delivering dynamic dashboards for students, parents, and educators',
      'Implemented live virtual classroom functionality using Socket.io and integrated Google Calendar API',
      'Engineered scalable and responsive user interfaces for multiple JavaScript-driven web applications',
      'Designed and delivered high-performance dashboard UI tailored to sales and transport teams',
      'Built immersive e-commerce websites with Shopify API integration and responsive design principles',
      'Delivered enterprise-grade dashboards for logistics, hospitality, and liquor sales industries'
    ],
  },
  {
    id: 'ny-solution',
    company: 'NY Solution',
    position: 'React JS Developer',
    duration: 'Sep 2021 - Dec 2021',
    location: 'Surat',
    description: 'Developed responsive and accessible user interfaces for web applications using modern React technologies.',
    technologies: ['JavaScript', 'TypeScript', 'jQuery', 'React.js', 'Redux Thunk', 'Formik', 'Node.js', 'Three.js', 'MongoDB', 'HTML', 'CSS', 'SCSS', 'Bootstrap'],
    achievements: [
      'Developed reusable, modular UI components using Bootstrap and Material UI',
      'Implemented responsive web design principles for cross-platform compatibility',
      'Integrated REST APIs for dynamic data fetching and state management',
      'Collaborated with design and backend teams to deliver high-quality user experiences'
    ],
  },
  {
    id: 'step-smith',
    company: 'STEP SMITH SOLUTION',
    position: 'Software Developer',
    duration: 'Sep 2020 - Aug 2021',
    location: 'Surat',
    description: 'Started career as a software developer, learning modern web technologies and best practices.',
    technologies: ['JavaScript', 'React.js', 'Next.js', 'Redux', 'React Hook', 'HTML', 'CSS', 'SCSS', 'Bootstrap', 'Material UI', 'Tailwind CSS'],
    achievements: [
      'Built responsive websites using HTML, CSS, and JavaScript',
      'Learned modern CSS frameworks and responsive design principles',
      'Developed interactive user interfaces with jQuery and Bootstrap',
      'Gained foundational knowledge in software development and web standards'
    ],
  },
];
